const copyProperties = (styles, element) => {
    Object.keys(styles).forEach((key) => {
        element.style[key] = styles[key];
    });
};

const animation = (element, start = {}, end = {}) => {
    return new Promise((resolve) => {
        copyProperties(start, element);
        const onTransitionEnd = () => {
            copyProperties(end, element);
            resolve(element);
        };

        requestAnimationFrame(() => {
            element.addEventListener('transitionend', onTransitionEnd, false);
        });
    });
};

const expand = (element, time = 600) => {
    return animation(element, {
        transition: `max-height ${time}ms, transform ${time}ms`,
        transformOrigin: 'top left',
        transform: 'scaleY(1)',
        maxHeight: `700px`,
    }, {
        maxHeight: `700px`,
    });
};

const collapse = (element, time = 600) => {
    return animation(element, {
        transition: `max-height ${time}ms, transform ${time}ms`,
        transformOrigin: 'top left',
        transform: 'scaleY(0)',
        maxHeight: '0',
    }, {
        maxHeight: '0',
    });
};


module.exports = {
    collapse,
    expand,
};
